"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultValues = void 0;
var defaultValues = exports.defaultValues = {
  collegeAge1: '18',
  collegeInflation: '5',
  rateReturn: '5',
  startIn: '0',
  contributionPercent: '100',
  collegeTerm: 'private 4-year'
};